module.exports = __webpack_public_path__ + "static/media/vodafone-regular.698efecf.woff";